import { render } from "./FieldCurrency.vue?vue&type=template&id=f0a96a0c"
import script from "./FieldCurrency.vue?vue&type=script&lang=js"
export * from "./FieldCurrency.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__